import { useEffect, useState } from 'react';
import { PodcastPlayerState, getState, subscribe } from '../services/podcastPlayer';

/** Uygulama genelindeki podcast oynatıcısının durumu (services/podcastPlayer.ts) */
export function usePodcastPlayer(): PodcastPlayerState {
    const [s, setS] = useState<PodcastPlayerState>(getState);
    useEffect(() => subscribe(setS), []);
    return s;
}
